import { template } from '@yola/ws-sdk';
import get from 'lodash.get';

const getSubmoduleConfig = (submoduleName) => {
  const getDesignAutomationConfig = template.accessors.getDesignAutomation();
  return get(getDesignAutomationConfig, submoduleName, {});
};

export default getSubmoduleConfig;
